import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getLoading, getData } from "../selectors";
import { RESET_STATE } from "../actionTypes";
import { getHistoricalDistributionCostAction } from "../actions";

const useHistoricalDistributionCost = (employeeCode) => {
  const dispatch = useDispatch();

  const data = useSelector(getData);
  const isLoading = useSelector(getLoading);

  useEffect(() => {
    dispatch(getHistoricalDistributionCostAction(employeeCode));
    return () => { dispatch({ type: RESET_STATE }) }
  }, [dispatch, employeeCode])

  return {
    isLoading,
    data,
  }
}

export default useHistoricalDistributionCost;